// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"7232219d","195":"0c3c4b9e","255":"6c554d51","312":"d41d18ef","390":"a23470af","487":"184f317f","509":"a337d7b4","589":"7aff1b13","761":"ebab0a7e","824":"a0fd2cf4","965":"c92903f0"}[chunkId] + ".chunk.js";
};